import { useState, useEffect } from 'react';
import { files } from '../api/files';

const STORAGE_URL_KEY = 'marketing_hub_storage_url';

export const useStorageUrl = () => {
  const [storageUrl, setStorageUrl] = useState<string>(() => {
    // Try to get cached URL from localStorage on init
    const cachedUrl = localStorage.getItem(STORAGE_URL_KEY);
    return cachedUrl || '';
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchStorageUrl = async () => {
      try {
        // Even if we have a cached URL, we still fetch to ensure it's up to date
        const response = await files.getStorageUrl();

        // Save to state and localStorage
        setStorageUrl(response.url);
        localStorage.setItem(STORAGE_URL_KEY, response.url);
      } catch (err) {
        setError(err as Error);
        // If we have a cached URL, keep using it even if the fetch fails
        if (!storageUrl) {
          console.error('Failed to fetch storage URL and no cached URL available');
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchStorageUrl();
  }, [storageUrl]);

  return { storageUrl, isLoading, error };
};
